import {Component, inject, Input, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {AuthService} from "../../../../shared-module/services/auth.service";
import {StarsComponent} from "../../../../shared-module/components/stars/stars.component";

import {CardComponent} from "../../../../shared-module/components/card/card.component";
import {ApplicationConfig, config} from "../../../../../config";
import RelationContact from "../../../../shared-module/model/relation-contact.model";
import {ActivatedRoute, Params} from "@angular/router";
import Survey from "../../../../shared-module/model/survey.model";

@Component({
    selector: 'app-thanks',
    imports: [
    StarsComponent,
    CardComponent
],
    templateUrl: './thanks.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./thanks.component.scss']
})

export class SurveyThanksComponent implements OnInit {
  protected readonly authService: AuthService = inject(AuthService);
  private readonly route: ActivatedRoute = inject(ActivatedRoute);

  @Input() imageSrc: string = '/success.svg';

  protected readonly config: ApplicationConfig = config;
  protected rating: number | null = null;

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      if (!params['id']) {
        return;
      }
      this.authService.getUser(['surveys']).subscribe((user: RelationContact | null) => {
        if (user === null) {
          return;
        }
        const foundSurvey: Survey | null = user.surveys?.find((survey: Survey) => survey.id == params['id']) ?? null;
        if (foundSurvey === null) {
          return;
        }
        this.rating = foundSurvey.rating;
      })
    });
  }
}
